import { render, staticRenderFns } from "./RevenuesTable.vue?vue&type=template&id=622cea88&"
import script from "./RevenuesTable.vue?vue&type=script&lang=js&"
export * from "./RevenuesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports